/* Collection grid swatches — Simply Carbon Fiber (2026-09-15). Hover shows the colour name (CSS tooltip);
   clicking or tapping a swatch swaps the card photo (and its hover photo) to that colour for the filtered device
   and points the card's links at it. The page never navigates until the photo or title is clicked. */
(function () {
  'use strict';
  function srcset(u) {
    return [360, 540, 720].map(function (w) { return u.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w'; }).join(', ');
  }
  /* 2026-09-27 (Sergio: the colour names get cut off): a name sits centred on its square, so long names on the
     middle squares ran past the card edge. Just before one shows, cap it at the card width and nudge it inside. */
  function fit(sw) {
    var tip = sw.querySelector('.scf-tip'), box = sw.closest('.grid-product__content') || sw.closest('.grid-product');
    if (!tip || !box) return;
    var b = box.getBoundingClientRect();
    tip.style.translate = '';
    tip.style.maxWidth = Math.max(80, Math.floor(b.width - 4)) + 'px';
    var t = tip.getBoundingClientRect(), dx = 0;
    if (!t.width) return;
    if (t.left < b.left + 2) dx = b.left + 2 - t.left;
    else if (t.right > b.right - 2) dx = b.right - 2 - t.right;
    if (dx) tip.style.translate = Math.round(dx) + 'px 0';
  }
  /* 2026-10-06 (Sergio: a colour with another price kept the first colour's price): the swatch carries its own price
     line (snippets/scf-card-price-data.liquid); a tap writes it into the card: price, old price struck, % off or Sold out.
     A colour is one variant, so "From" goes; a product-group swatch whose product has several prices keeps it. */
  function price(card, sw) {
    if (sw.dataset.price == null) return;
    var line = card.querySelector('.grid-product__price'); if (!line) return;
    var now = line.querySelector('.grid-product__price--current'), was = line.querySelector('.grid-product__price--original'), tag = line.querySelector('.grid-product__price--pct');
    if (!now) return;
    now.textContent = '';
    if (sw.dataset.from) { var f = document.createElement('span'); f.className = 'scf-from'; f.textContent = sw.dataset.from; now.appendChild(f); now.appendChild(document.createTextNode(' ')); }
    now.appendChild(document.createTextNode(sw.dataset.price));
    line.classList.toggle('is-from', !!sw.dataset.from);
    if (sw.dataset.was) {
      if (!was) { was = document.createElement('s'); was.className = 'grid-product__price--original'; now.insertAdjacentElement('afterend', was); }
      was.textContent = sw.dataset.was; was.style.display = '';
    } else if (was) was.style.display = 'none';
    var pct = +sw.dataset.pct || 0, so = sw.dataset.so;
    if (so || pct > 0) {
      if (!tag) { tag = document.createElement('span'); tag.className = 'grid-product__price--pct'; (was || now).insertAdjacentElement('afterend', tag); }
      tag.textContent = so ? so : pct + '% off'; tag.classList.toggle('is-so', !!so); tag.style.display = '';
    } else if (tag) tag.style.display = 'none';
  }
  function bind(sw) {
    if (sw.__scf) return; sw.__scf = true;
    var card = sw.closest('.grid-item, .grid-product, .grid__item') || sw.parentElement.parentElement;
    var pick = function () {
      var url = sw.dataset.url, id = sw.dataset.variantId, img = sw.dataset.variantImage, hov = sw.dataset.variantHover;
      if (url) card.querySelectorAll('a.grid-product__link, a.grid-item__link, .grid__item-image-wrapper a, a.grid-product__image-link').forEach(function (a) { a.setAttribute('href', url); });
      card.querySelectorAll('.grid-product__colors .is-active').forEach(function (x) { x.classList.remove('is-active'); });
      sw.classList.add('is-active');
      if (id && img) {
        var mask = card.querySelector('.grid-product__image-mask') || card.querySelector('.grid__item-image-wrapper');
        var el = card.querySelector('.grid-product__color-image--' + id);
        if (!el && mask) { el = document.createElement('div'); el.className = 'grid-product__color-image grid-product__color-image--' + id; mask.appendChild(el); }
        /* 2026-09-27: the grey colour layer used to go up at once and cover the card until its photo arrived (a blank
           tile on phones). Now the current photo stays until the new one has loaded; the last tap wins. */
        card.__scfPick = id;
        var show = function () {
          if (card.__scfPick !== id || !el) return;
          card.querySelectorAll('.grid-product__color-image.is-active').forEach(function (x) { if (x !== el) x.classList.remove('is-active'); });
          el.classList.remove('small--hide'); /* the theme hides colour layers on phones; tapping a swatch must show it */
          el.style.backgroundImage = 'url(' + img + ')';
          if (window.SCFCard) window.SCFCard.layer(el, img); /* 2026-09-29: the colour photo is sized like the card's own */
          el.classList.add('is-active');
        };
        var pre = new Image();
        pre.onload = show;
        pre.src = img;
        if (pre.complete && pre.naturalWidth) show();
      }
      var h = card.querySelector('.grid-product__secondary-image img');
      if (h && hov) { h.srcset = srcset(hov); h.src = hov; h.removeAttribute('data-srcset'); }
      price(card, sw);
    };
    var nudge = function () { fit(sw); };
    sw.addEventListener('mouseenter', nudge);
    sw.addEventListener('focus', nudge);
    sw.addEventListener('touchstart', nudge, { passive: true });
    sw.addEventListener('click', function (e) { e.preventDefault(); pick(); fit(sw); });
    sw.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
  }
  function boot() { document.querySelectorAll('.grid-product__colors .color-swatch--small').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  new MutationObserver(function () { boot(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* The card — Simply Carbon Fiber (2026-09-29, decks 247-249, Sergio "go").
   1. Photos: every photo is shown at the same scale, 90% of its tile, as shot (2026-10-04, deck 270 v2). The product sizes
      come from the photos themselves (the 2026-09-28 photo pass: most products fill 95% of the photo, AirPods and Buds
      75% so they stay true to their real size, Pop-Up Wallets real size, rings 90%), so families keep the sizes chosen
      for them. Until 2026-10-04 each product was resized to 78% of the tile's width / 74% of its height, which enlarged
      the AirPods to the size of the phone cases. The outline of the product in each photo was measured once and is
      stored in assets/scf-card-outlines.json (key = a short hash of the file name; value = [left, top, right, bottom] in
      thousandths, a fifth number when the photo is not square; 0 = the photo fills its frame, leave it: a model, a
      close-up, anything that runs off an edge). A photo that is not in the file is measured here, once, and remembered
      on the device. The sizes are percentages, so nothing is recalculated when the window changes.
   2. Long prices: when a price line does not fit (other currencies on phones), the grid steps down, see merchant.css. */
(function () {
  'use strict';
  var SCALE = 0.90;   /* every photo at 90% of its tile; was a per-product fit to 78% wide / 74% tall */
  var SRC = window.SCF_CARD_OUTLINES || '', MAP = null, EXTRA = {}, EXTRA_KEY = 'scf-card-outlines:extra2', queue = [];
  var root = document.documentElement;
  try { EXTRA = JSON.parse(localStorage.getItem(EXTRA_KEY) || '{}') || {}; } catch (e) { EXTRA = {}; }

  function hash(s) {
    var h = 0x811c9dc5, b = unescape(encodeURIComponent(s));
    for (var i = 0; i < b.length; i++) { h ^= b.charCodeAt(i); h = Math.imul(h, 0x01000193); }
    return (h >>> 0).toString(36);
  }
  function fileOf(u) { u = String(u || '').split('?')[0].split('#')[0]; return u.substring(u.lastIndexOf('/') + 1); }
  function small(u) {
    u = String(u || '');
    if (/([?&])width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=200');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200';
  }
  function find(h) { if (MAP && h in MAP) return MAP[h]; if (h in EXTRA) return EXTRA[h]; return undefined; }
  function remember(h, v) {
    EXTRA[h] = v;
    try { var k = Object.keys(EXTRA); if (k.length > 600) { EXTRA = {}; EXTRA[h] = v; } localStorage.setItem(EXTRA_KEY, JSON.stringify(EXTRA)); } catch (e) {}
  }
  /* the outline of the product: every pixel that is not the white of the studio */
  function measure(u, done) {
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var S = 160, c = document.createElement('canvas'); c.width = S; c.height = S;
        var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, S, S); x.drawImage(im, 0, 0, S, S);
        var d = x.getImageData(0, 0, S, S).data, l = S, t = S, r = -1, b = -1;
        for (var j = 0; j < S; j++) for (var i = 0; i < S; i++) {
          var o = (j * S + i) * 4;
          if (d[o] < 232 || d[o + 1] < 232 || d[o + 2] < 232) { if (i < l) l = i; if (i > r) r = i; if (j < t) t = j; if (j > b) b = j; }
        }
        if (r < 0) return done(0);
        var v = [Math.round(l / S * 1000), Math.round(t / S * 1000), Math.round((r + 1) / S * 1000), Math.round((b + 1) / S * 1000)];
        if (v[2] - v[0] > 970 && v[3] - v[1] > 970) return done(0);
        /* a photo whose subject runs off an edge (a model, a close-up, a hand holding the product) is composed to fill
           its frame: more than 5% of any edge covered means leave it whole. A cut-out floats clear of the edges. */
        var ink = function (i, j) { var o = (j * S + i) * 4; return d[o] < 232 || d[o + 1] < 232 || d[o + 2] < 232; };
        var e = [0, 0, 0, 0];
        for (var n = 0; n < S; n++) { if (ink(n, 0)) e[0]++; if (ink(S - 1, n)) e[1]++; if (ink(n, S - 1)) e[2]++; if (ink(0, n)) e[3]++; }
        if (Math.max(e[0], e[1], e[2], e[3]) / S >= 0.05) return done(0);
        var ar = im.naturalWidth / im.naturalHeight;
        if (Math.abs(ar - 1) > 0.01) v.push(Math.round(ar * 1000) / 1000);
        done(v);
      } catch (e) { done(null); }
    };
    im.onerror = function () { done(null); };
    im.src = small(u);
  }
  /* zoom for an outline, in a frame of the given shape (width / height): the same scale for every photo, no shift
     (the photos are centred already), so each product keeps the size its photo gives it */
  function place(v, frame) {
    if (!v || !v.length) return null;
    var ar = v[4] || 1, rw = 1, rh = 1;
    if (ar >= frame) rh = frame / ar; else rw = ar / frame;
    var w = (v[2] - v[0]) / 1000 * rw, h = (v[3] - v[1]) / 1000 * rh;
    if (w < 0.02 || h < 0.02) return null;
    return { k: SCALE, rw: rw, rh: rh, cx: 0.5, cy: 0.5 };
  }
  function frameOf(el) { var w = el.clientWidth, h = el.clientHeight; return w > 0 && h > 0 ? w / h : 1; }
  /* 2026-10-14 (Sergio "go blocks"): a photo that fills its frame (outline 0: a close-up, a model) or that could not be
     measured is shown like every other photo, whole at 90% of its tile, so every card matches the Classic cases. It used
     to fill the tile edge to edge (the Camera Protectors, the coaster sets, the cable, two watches, the strap, the money
     clip). The hover photo (desktop) keeps filling its tile, as on every card. */
  function whole(ar) { var v = [0, 0, 1000, 1000]; if (ar > 0 && Math.abs(ar - 1) > 0.01) v.push(ar); return v; }
  function setImg(img, v) {
    var p = place(v, frameOf(img));
    if (!p && !img.closest('.grid-product__secondary-image')) p = place(whole(img.naturalHeight ? img.naturalWidth / img.naturalHeight : 1), frameOf(img));
    if (!p) { img.style.removeProperty('--scf-k'); img.style.removeProperty('--scf-tx'); img.style.removeProperty('--scf-ty'); img.style.setProperty('--scf-fit', 'cover'); return; }
    img.style.removeProperty('--scf-fit');
    img.style.setProperty('--scf-k', p.k.toFixed(4));
    img.style.setProperty('--scf-tx', (-p.k * (p.cx - 0.5) * p.rw * 100).toFixed(3) + '%');
    img.style.setProperty('--scf-ty', (-p.k * (p.cy - 0.5) * p.rh * 100).toFixed(3) + '%');
  }
  function setLayer(el, v, u) {
    var p = place(v, frameOf(el));
    if (!p) {
      /* a colour photo that fills its frame: its shape is read from the photo (already loaded before the layer shows) */
      var me = el.__scfPhoto, im = new Image();
      var at = function () { if (el.__scfPhoto === me && im.naturalWidth) layerAt(el, place(whole(im.naturalWidth / im.naturalHeight), frameOf(el))); };
      el.style.backgroundSize = ''; el.style.backgroundPosition = '';
      if (!u) return;
      im.onload = at; im.src = u; if (im.complete) at();
      return;
    }
    layerAt(el, p);
  }
  function layerAt(el, p) {
    if (!p) return;
    var sw = p.k * p.rw, sh = p.k * p.rh;
    var px = Math.abs(1 - sw) < 0.001 ? 50 : (0.5 - sw * p.cx) / (1 - sw) * 100;
    var py = Math.abs(1 - sh) < 0.001 ? 50 : (0.5 - sh * p.cy) / (1 - sh) * 100;
    el.style.backgroundSize = (sw * 100).toFixed(3) + '% ' + (sh * 100).toFixed(3) + '%';
    el.style.backgroundPosition = px.toFixed(3) + '% ' + py.toFixed(3) + '%';
  }
  function size(el, u, set) {
    if (!u) return;
    var h = hash(fileOf(u));
    if (el.__scfPhoto === h) return;
    el.__scfPhoto = h;
    if (!MAP && SRC) { queue.push(function () { el.__scfPhoto = null; size(el, u, set); }); return; }
    var v = find(h);
    if (v !== undefined) { set(el, v, u); return; }
    measure(u, function (r) {
      if (r !== null) remember(h, r);
      if (el.__scfPhoto === h) set(el, r, u);
    });
  }
  function photos(scope) {
    (scope || document).querySelectorAll('.scf-card .grid-product__image-mask img').forEach(function (img) {
      size(img, img.currentSrc || img.getAttribute('src'), setImg);
    });
  }
  window.SCFCard = { layer: function (el, u) { if (el.closest('.scf-card')) { el.__scfPhoto = null; size(el, u, setLayer); } } };

  /* ---- long prices ---- */
  function prices() {
    var grids = [];
    document.querySelectorAll('.scf-card').forEach(function (c) {
      var g = c.closest('.grid') || c.parentElement.parentElement;
      if (g && grids.indexOf(g) < 0) grids.push(g);
    });
    grids.forEach(function (g) {
      var cards = [].slice.call(g.querySelectorAll('.scf-card')).filter(function (c) { return c.offsetParent !== null; });
      if (!cards.length) return;
      g.classList.remove('scf-fit1', 'scf-fit2', 'scf-fit3');
      cards.forEach(function (c) { c.classList.remove('scf-fit2'); });
      var bad = function () {
        return cards.filter(function (c) { var p = c.querySelector('.grid-product__price'); return p && p.scrollWidth > p.clientWidth + 1; });
      };
      if (!bad().length) return;
      g.classList.add('scf-fit1');
      var b = bad();
      if (!b.length) return;
      if (b.length <= cards.length * 0.25) b.forEach(function (c) { c.classList.add('scf-fit2'); });
      else g.classList.add('scf-fit2');
      if (bad().length) g.classList.add('scf-fit3');
    });
  }

  var t1 = null, t2 = null;
  function later() { clearTimeout(t1); t1 = setTimeout(function () { photos(); prices(); }, 60); }
  function ready() { root.classList.remove('scf-cards-pending'); }
  function start() {
    photos(); prices(); if (MAP || !SRC) ready();
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) if (list[i].addedNodes && list[i].addedNodes.length) { photos(); later(); return; }
    }).observe(document.body, { childList: true, subtree: true });
    /* a photo that changes (a colour picked, the hover photo swapped) is sized again once it has loaded */
    document.addEventListener('load', function (e) {
      var img = e.target;
      if (img && img.tagName === 'IMG' && img.closest && img.closest('.scf-card .grid-product__image-mask')) size(img, img.currentSrc || img.getAttribute('src'), setImg);
    }, true);
    window.addEventListener('resize', function () { clearTimeout(t2); t2 = setTimeout(prices, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(prices);
  }
  function loaded(map) {
    MAP = map || {};
    var q = queue; queue = [];
    q.forEach(function (f) { f(); });
    ready();
  }
  if (SRC) {
    var CK = 'scf-card-outlines:' + (SRC.split('?v=')[1] || ''), cached = null;
    try { cached = sessionStorage.getItem(CK); } catch (e) {}
    if (cached) { try { MAP = JSON.parse(cached); } catch (e) { MAP = null; } }
    if (!MAP) {
      fetch(SRC).then(function (r) { return r.text(); }).then(function (txt) {
        var m = JSON.parse(txt);
        try { sessionStorage.setItem(CK, txt); } catch (e) {}
        loaded(m);
      }).catch(function () { loaded({}); });
    }
  }
  setTimeout(ready, 1500); /* never hold the photos longer than this, whatever happens */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
